import { CalendarStateTypes, CalendarActionTypes } from "./Calendar.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: CalendarStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const CalendarReducer = (
  state: CalendarStateTypes = INITIAL_STATE,
  action: any
): CalendarStateTypes => {
  switch (action.type) {
    case CalendarActionTypes.FETCH_ALL_CALENDAR:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case CalendarActionTypes.FETCH_ALL_CALENDAR_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case CalendarActionTypes.FETCH_ALL_CALENDAR_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case CalendarActionTypes.FETCH_ALL_CALENDAR_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case CalendarActionTypes.FETCH_ONE_CALENDAR:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case CalendarActionTypes.FETCH_ONE_CALENDAR_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case CalendarActionTypes.FETCH_ONE_CALENDAR_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case CalendarActionTypes.FETCH_ONE_CALENDAR_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default CalendarReducer;
